var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.22,0V4.56H0V6.49H41.22v5.14l8.78-6Z"}));
}

ArrowR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 50 11.63"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
